import * as actionTypes from 'src/app/state/actions/types';

import type { CustomErrorModal } from '../reducers';

export type ModalPayload = {
  modalType: 'confirm' | 'ok';
  handleConfirmClick: (arg: any) => void;
  confirmMessage: string;
};
export function openModal(modal: ModalPayload) {
  return {
    type: actionTypes.MODAL,
    modal: { ...modal },
  };
}

export function closeModal() {
  return {
    type: actionTypes.MODAL,
    modal: { modalType: null },
  };
}

export function setShowFamilyModal(showModal: boolean, dependentName: string) {
  return {
    type: actionTypes.FAMILY_MODAL,
    showModal,
    dependentName,
  };
}

export function setShowFaqModal(showModal: boolean) {
  return {
    type: actionTypes.FAQ_MODAL,
    showModal,
  };
}

interface SetRequestRefillModalStatusArgs {
  isShown: boolean;
  success: boolean;
}
/**
 * # setRequestRefillModalStatus
 * Sets the boolean value for whether to display the request refill status modal, as well as the boolean
 * for whether the request of a refill task was successful.
 *
 * @param {bool} isShown instructs whether or not to show the request refill status modal
 * @param {bool} success indicates whether or not a request refill task was successufully created
 */
export function setRequestRefillModalStatus({ isShown, success }: SetRequestRefillModalStatusArgs) {
  return {
    type: actionTypes.SET_REQUEST_REFILL_MODAL_STATUS,
    isShown: isShown,
    success: success,
  };
}

export function setNewArchivedPageModalShown() {
  return {
    type: actionTypes.SET_NEW_ARCHIVED_PAGE_MODAL_SHOWN,
  };
}

export function setShowNewArchivedPageModal(showModal: boolean) {
  return {
    type: actionTypes.NEW_ARCHIVED_PAGE_MODAL,
    showModal,
  };
}

export function setModalWithCustomError(error: CustomErrorModal) {
  return {
    type: actionTypes.SET_CUSTOM_ERROR_MODAL,
    error,
  };
}

export function clearNetworkErrors() {
  return {
    type: actionTypes.CLEAR_NETWORK_ERRORS,
  };
}
